import '../../styles/modales.css';
import React, { useEffect, useState } from "react";
import Navbar from "../../navbar/navbar";
import Sidebar from "../../navbar/sidebar";
import { Card, Pagination, Table, Button, Col, InputGroup,Form }
  from "react-bootstrap";
import {
  BsChevronExpand,
  BsChevronLeft,
  BsChevronRight
} from "react-icons/bs";

import { addDays, parseISO } from 'date-fns';

import { getAllActas } from '../../services/apiService';
import "../../App.css"
import "../../App.css"
import { FcSearch } from "react-icons/fc";

let monthNamesC = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export default function Todas() {
  document.title = "Actas Circunstanciadas";
  // Paginación
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [folio, setFolio] = useState("");
  const [folioInput, setFolioInput] = useState("");
  const [estadoId, setEstadoId] = useState("");
  const [estadoInput, setEstadoIdInput] = useState("");

  //Novo
  const [actas, setActas] = useState([]);

  const handleAplicarFiltros = () => {
    setFolio(folioInput || null);
    setEstadoId(estadoInput || null);
    setCurrentPage(0); // volver a la primera página
  };

  const handleLimpiarFiltros = () => {
    setFolioInput('');
    setFolio('');
    setEstadoId('');
    setEstadoIdInput('');
    setCurrentPage(0);
  };

  const getData = async (event) => {
    try {
      let response;
      response = await getAllActas(
        currentPage,
        pageSize,
        folio,
        estadoId,
      )
      setActas(response.acta || []);
      setTotalPages(response.totalPages || 0);
      setTotalElements(response.totalItems || 0);


    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line 
  }, [
    currentPage,
    pageSize,
    folio,
    estadoId,
  ]);

  // Inicio Paginación

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    if (totalPages === 0) return;

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };
  const getPaginationItems = () => {
    let items = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

    // Ajustar si estamos cerca del final
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }

    // Primera página
    if (startPage > 0) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => handlePageChange(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }

    // Páginas intermedias
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i + 1}
          active={i === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }

    // Última página
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };
  // Fin Paginación

  function fechaFin(fecha_inicio, dias_habiles) {
    //const Hoy = new Date();
    const fechaISO = fecha_inicio;
    const dias = dias_habiles;
    const fecha = parseISO(fechaISO);
    const nuevaFecha = addDays(fecha, dias);
    const nuevaFechaISO = nuevaFecha.toISOString();
    //const fecha2 = parseISO(nuevaFechaISO);
    //const mseg_dia=1000*60*60*24;
    //const dia = Math.ceil((fecha2.getTime()-Hoy.getTime())/(mseg_dia));
    return nuevaFechaISO;
  };

  function diasRestantes(fecha_inicio, dias_habiles) {

    const Hoy = new Date();
    console.log({ Hoy });
    const fechaISO = fecha_inicio;
    console.log({ fechaISO });
    const dias = dias_habiles;
    console.log({ dias });
    const fecha = parseISO(fechaISO);
    console.log({ fecha });
    const nuevaFecha = addDays(fecha, dias);
    console.log({ nuevaFecha });
    const nuevaFechaISO = nuevaFecha.toISOString();
    console.log({ nuevaFechaISO });
    const fecha2 = parseISO(nuevaFechaISO);
    console.log({ fecha2 });
    const mseg_dia = 1000 * 60 * 60 * 24;
    console.log({ mseg_dia });
    const dia = Math.ceil((fecha2.getTime() - Hoy.getTime()) / (mseg_dia));
    console.log({ dia });
    if (dia < 0) {
      return dia - dia;
    } else {
      return dia;
    }
  };


  return (
    <div className="flex">
      <Sidebar />
      <div className="content w-100 cont">
        <Navbar />

        <h2 className=" text-center bluetext">
          <strong>ACTAS REGISTRADAS{" "}
          </strong>
        </h2>

        <Card className="card-tabla">
          <Table
            hover
            size="sm"
            responsive
            className="tablecursos text-center"
          >
            <thead className="table-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Oficio</th>
                <th scope="col">Inicio de estatus</th>
                <th scope="col">Finalización de estatus</th>
                <th scope="col">Estatus</th>
                <th scope="col">Días restantes</th>
              </tr>
            </thead>
            <tbody>
              {actas.length > 0 ? (
                actas.map((acta, i) => (
                  <tr key={acta.id} >
                    <td>{i + 1}</td>
                    <td>{acta.folio}</td>
                    <td>
                      {
                        acta.estadosacta.id === 1 ? (
                          <>
                            {" " +
                              new Date(acta.creado).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.creado).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.creado).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 2 ? (
                          <>
                            {" " +
                              new Date(acta.tiempo).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.tiempo).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.tiempo).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 3 ? (
                          <>
                            {" " +
                              new Date(acta.tiempo).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.tiempo).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.tiempo).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 4 ? (
                          <>
                            {" " +
                              new Date(acta.tiempo).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.tiempo).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.tiempo).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 5 ? (
                          <>
                            {" " +
                              new Date(acta.tiempo).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.tiempo).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.tiempo).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 6 ? (
                          <>
                            {" " +
                              new Date(acta.tiempo).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(acta.tiempo).getUTCMonth()
                              ] +
                              "/" +
                              new Date(acta.tiempo).getUTCFullYear()
                            }
                          </>
                        ) : null
                      }

                    </td>
                    <td>
                      {
                        acta.estadosacta.id === 1 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.creado, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.creado, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.creado, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 2 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 3 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 4 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 5 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : acta.estadosacta.id === 6 ? (
                          <>
                            {" " +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCDate() +
                              "/" +
                              monthNamesC[
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCMonth()
                              ] +
                              "/" +
                              new Date(fechaFin(acta.tiempo, acta.dias_habiles)).getUTCFullYear()
                            }
                          </>
                        ) : null
                      }
                    </td>
                    <td>
                      <strong>{acta.estadosacta.estado}</strong>
                    </td>
                    <td>
                      {diasRestantes(acta.tiempo, acta.dias_habiles)}

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No hay registros para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </Table>


        </Card>
        <Card className="card-fix">
          <div className="d-flex justify-content-between align-items-center ">
            <div className="d-flex align-items-center gap-2">
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Folio</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text>
                      <FcSearch />
                    </InputGroup.Text>
                    <Form.Control
                      placeholder="Buscar por Folio..."
                      value={folioInput}
                      onChange={(e) => setFolioInput(e.target.value)}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Estado</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsChevronExpand /> {" "}
                    </InputGroup.Text>
                    <Form.Select
                      className="form-control"
                      name="estadoInput"
                      value={estadoInput}
                      onChange={(e) => setEstadoIdInput(e.target.value)}
                    >
                      <option value="">-- Seleccione estado --</option>
                      <option value="1">Levantamiento</option>
                      <option value="2">Apercibimiento</option>
                      <option value="3">Amonestación</option>
                      <option value="4">Procedimiento Administrativo Sancionador</option>
                      <option value="5">Dictamen técnico de riesgos</option>
                      <option value="6">Suspensión de actividades</option>
                      
                    </Form.Select>

                  </InputGroup>
                </div>
              </Col>

              <Col xs={6} md={3} className="d-flex gap-2">
                <Button
                  variant="success"
                  className="w-100"
                  onClick={handleAplicarFiltros}
                >
                  Aplicar
                </Button>

                <Button
                  variant="dark"
                  className="w-100"
                  onClick={handleLimpiarFiltros}
                >
                  Limpiar
                </Button>
              </Col>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center ">
            <div className="d-flex align-items-center gap-2">
              <span>Registros por página:</span>
              <select
                className="form-select form-select-sm"
                value={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: "80px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>

            </div>
            <div className="text-muted">
              Mostrando{" "}
              <strong>
                {currentPage * pageSize + 1}-
                {Math.min((currentPage + 1) * pageSize, totalElements)}
              </strong>{" "}
              de <strong>{totalElements}</strong> registros
            </div>

            <div className="d-flex align-items-center gap-2">
              <Button
                variant="outline-dark"
                onClick={handlePrevious}
                disabled={currentPage === 0}
                className="d-flex align-items-center gap-1"
              >
                <BsChevronLeft />
                <span>Anterior</span>
              </Button>

              <Pagination className="mb-0">
                {getPaginationItems()}
              </Pagination>

              <Button
                variant="outline-dark"
                onClick={handleNext}
                disabled={currentPage >= totalPages - 1}
                className="d-flex align-items-center gap-1"
              >
                <span>Siguiente</span>
                <BsChevronRight />
              </Button>
            </div>
          </div>
        </Card>


      </div>
    </div>

  );
}
